var React = require('react');

function IconIndustry (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:currentColor;}")),React.createElement("title",{"key":1},"Asset 2"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"className":"cls-1","d":"M2,0A2,2,0,0,0,0,2V38.56a1.37,1.37,0,0,0,.42,1,1.37,1.37,0,0,0,1,.42H38.58A1.45,1.45,0,0,0,40,38.56V12.84a1.43,1.43,0,0,0-2.32-1.12l-12,9.58V12.84a1.43,1.43,0,0,0-2.32-1.12L11,21V2A2,2,0,0,0,9,0Z"})))]);
}

IconIndustry.defaultProps = {"viewBox":"0 0 40.01 39.99"};

module.exports = IconIndustry;

IconIndustry.default = IconIndustry;
